<div class="main">
  <div class="bodySection">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <!-- <div class="tabs">
      <div [ngClass]="{'switchSelected':tabIndex === 0, 'switch':tabIndex===1}" (click)="tabIndex=0">
        BASIC
      </div>
      <div [ngClass]="{'switchSelected':tabIndex === 1, 'switch':tabIndex===0}" (click)="tabIndex=1">
        ADVANCED
      </div>
    </div> -->
    <!-- <div [hidden]='tabIndex!=0'>
      <div class="header">
        RATECARD (BASIC)
      </div>
      <div class="rateCard">
        <table mat-table [dataSource]="rateCardBasicArr" class="mat-elevation-z8">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> date </th>
            <td mat-cell *matCellDef="let element"> {{element.date}} </td>
          </ng-container>

          <ng-container matColumnDef="Date">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
              <div class="date">
                <i class="material-icons">date_range</i><input type="text" placeholder="Date">
              </div>
            </th>
          </ng-container>

          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef> From </th>
            <td mat-cell *matCellDef="let element"> {{element.from}} </td>
          </ng-container>

          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef> To </th>
            <td mat-cell *matCellDef="let element"> {{element.to}} </td>
          </ng-container>

          <ng-container matColumnDef="fare">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> </th>
            <td mat-cell *matCellDef="let element"> {{element.fare}} </td>
          </ng-container>

          <ng-container matColumnDef="Fare">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Fare <br><span class="rupees">(Rs)</span></th>
          </ng-container>

          <ng-container matColumnDef="additionalCharges">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> </th>
            <td mat-cell *matCellDef="let element"> {{element.additionalCharges}} </td>
          </ng-container>

          <ng-container matColumnDef="AdditionalCharges">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Additional <br> charges <br><span
                class="charges">(Diesel,Toll,etc)</span></th>
          </ng-container>

          <ng-container matColumnDef="shipperId">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> ShipperId </th>
            <td mat-cell *matCellDef="let element"> {{element.shipperId}} </td>
          </ng-container>

          <ng-container matColumnDef="ShipperId">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">ShipperID</th>
          </ng-container>

          <ng-container matColumnDef="header-row-location">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Location </th>
          </ng-container>

          <tr mat-header-row
            *matHeaderRowDef="['Date', 'header-row-location', 'Fare', 'AdditionalCharges', 'ShipperId']"></tr>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplayBasic"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplayBasic;"></tr>

        </table>
      </div>
    </div> -->
    <!-- <div [hidden]='tabIndex!=1'>
      <div class="header">
        RATECARD (ADVANCED)
      </div>
      <div class="rateCard">
        <table mat-table [dataSource]="rateCardAdvancedArr" class="mat-elevation-z8">

          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>
              <div class="from">
                <i class="material-icons search">
                  search
                </i>
                <input type="text" placeholder="From">

              </div>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.from}} </td>
          </ng-container>

          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>
              <div class="to">
                <i class="material-icons search">
                  search
                </i>
                <input type="text" placeholder="To">
              </div>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.to}} </td>
          </ng-container>

          <ng-container matColumnDef="dateFrom">
            <th mat-header-cell *matHeaderCellDef>
              <div class="dateFrom">
                <i class="material-icons">date_range</i>
                <input type="text" placeholder="From">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div>{{element.dateFrom}} <br> {{element.timeFrom}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="dateTo">
            <th mat-header-cell *matHeaderCellDef>
              <div class="dateTo">
                <i class="material-icons search">
                  date_range
                </i>
                <input type="text" placeholder="To">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div>{{element.dateTo}} <br> {{element.timeTo}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="fare">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> </th>
            <td mat-cell *matCellDef="let element"> {{element.fare}} </td>
          </ng-container>

          <ng-container matColumnDef="Fare">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Fare <br><span class="rupees">(Rs)</span></th>
          </ng-container>

          <ng-container matColumnDef="additionalCharges">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> </th>
            <td mat-cell *matCellDef="let element"> {{element.additionalCharges}} </td>
          </ng-container>

          <ng-container matColumnDef="AdditionalCharges">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Additional <br> charges <br><span
                class="charges">(Diesel,Toll,etc)</span></th>
          </ng-container>

          <ng-container matColumnDef="shipperId">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> ShipperId </th>
            <td mat-cell *matCellDef="let element"> {{element.shipperId}} </td>
          </ng-container>

          <ng-container matColumnDef="ShipperId">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">ShipperID</th>
          </ng-container>


          <ng-container matColumnDef="header-row-location">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Location </th>
          </ng-container>

          <ng-container matColumnDef="header-row-date">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Date </th>
          </ng-container>

          <tr mat-header-row
            *matHeaderRowDef="['header-row-location', 'header-row-date', 'Fare', 'AdditionalCharges', 'ShipperId']">
          </tr>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplayAdvanced"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplayAdvanced;"></tr>
        </table>
      </div>
    </div> -->
  
    <div class="bodyHeader">
      <div class="rate">
        <div class="title">
          <div class="label">
            {{'RATECARD.rateCard' | translate}}
          </div>
          <div class="help">
            <!-- <app-help [helpData]="helpData" ></app-help> -->
          </div>
        </div>
        
      </div>
      <div class="filter">
        <div class="container" style=" width: 75%;">
            <span>{{'RATECARD.shipper' | translate}}</span>
            <mat-select class="inputSelect" (selectionChange)="getRatesForShipper();" [(ngModel)]="selectedShipper" style="color: #fff;">
                <mat-option *ngFor="let shipper of shipperArray" [value]="shipper">
                  {{shipper.name}}
                </mat-option>
              </mat-select>
        </div>   
        <div class="container" style=" width: 25%;">
          <span>{{'RATECARD.type' | translate}}</span> : {{selectedShipper.type_string || 'N/A'}}
        </div>
      </div>
    </div>
    <div class="rateBody" *ngIf="rateCardArray.length">
      <div class="rateSection">
        <div class="rateTable" [ngClass]="{expand: showVehiclesTab==0, compress: showVehiclesTab==1}">
          <table mat-table  [dataSource]="rateCardArray">
  
            <ng-container matColumnDef="{{column}}" *ngFor="let column of vehicleColumns; let i = index;">
              <th mat-header-cell *matHeaderCellDef class="customHeader">
                <div class="input" *ngIf="column=='from'"> From </div>
                <div class="input" *ngIf="column=='to'"> To </div>
                <div class="input" *ngIf="column=='fromDate'"> From </div>
                <div class="input" *ngIf="column=='toDate'"> To </div>
                <div class="input" *ngIf="i > 3 && i <= vehicleColumns.length - 1"> {{column}} ({{ currencySymbol }}) </div>
                
              </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="column=='from'||column== 'to';"> {{element[column]}}</span>
                <span *ngIf="column=='fromDate'||column== 'toDate';"> {{element[column]}}  <i class="material-icons calendar">date_range</i></span>
                <span *ngIf="i > 3 && i <= vehicleColumns.length - 1">{{element.vehicleRates[i]}}</span>
  
              </td>
            </ng-container>
  
  
            <ng-container matColumnDef="{{item}}" *ngFor="let item of headerColumns; let i = index;">
              <th class="customHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="(i == 0 || i == 1)? 2 : 1">
                <div *ngIf="i == 0">{{(item == 'range') ? 'Range' : (item == 'lane') ? 'Lanes' : 'Location'}}</div>
                <div *ngIf="i == 1">{{'RATECARD.valid' | translate}}</div>
              </th>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="headerColumns; sticky: true;"></tr>
            <tr mat-header-row *matHeaderRowDef="vehicleColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row; columns: vehicleColumns; let ind = index;" (click)="openVehiclesTab(row)"
              [ngClass]="{'highlightRow':row._id == selectedLane._id}"></tr>
          </table>
        </div>
        <div class="vehiclesTab" *ngIf="showVehiclesTab == 1 && rateCardArray.length">
          <i class="material-icons" (click)="showVehiclesTab=0;selectedLane={};">clear</i>
          <div class="statusHeader">
            <div class="text">
              <span *ngIf="selectedShipper.sub_type == 'basic'"> Rate Vehicles </span>
              <span *ngIf="selectedShipper.sub_type != 'basic'"> Rate for weight </span>
            </div>
          </div>
          <div class="statusBody">
            <div class="vehicleRates" *ngFor="let item of selectedLane.vehicleRates">
              <div class="vehicleRow">
                <div class="vehicle">
                  {{(item.vehicle_type) ? item.vehicle_type.name || 'NA' : 'NA'}}
                </div>
                <div class="price">
                  {{(item.price) ? currencySymbol + item.price : 'NA'}}
                </div>
              </div>
            </div>
            <div class="vehicleRates" *ngIf="selectedLane.weightRate">
              <div class="vehicleRow">
                <div class="vehicle">
                  1 {{ selectedLane.weightRate ? selectedLane.weightRate.unit || "NA" : "NA" }}
                </div>
                <div class="price">
                  {{ selectedLane.weightRate.price ? currencySymbol + selectedLane.weightRate.price : "NA" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="weightRate" *ngIf="weightRateArray.length;">
      <table mat-table  [dataSource]="weightRateArray">
        <ng-container matColumnDef="from">
          <th mat-header-cell *matHeaderCellDef> Form </th>
          <td mat-cell *matCellDef="let row"> {{row.from}} </td>
        </ng-container>
        <ng-container matColumnDef="to">
          <th mat-header-cell *matHeaderCellDef> To </th>
          <td mat-cell *matCellDef="let row"> {{row.to}} </td>
        </ng-container>
        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="selectedShipper.type == 'weight' ">
              Rate Per Ton ({{currencySymbol}})
            </span>
            <span *ngIf="selectedShipper.type == 'package'">
              Rate Per Package ({{currencySymbol}})
            </span>
            <span *ngIf="selectedShipper.type == 'cbm'">
              Rate Per CBM ({{currencySymbol}})
            </span>
          </th>
          <td mat-cell *matCellDef="let row"> {{row.rate}} </td>
        </ng-container>
        <ng-container matColumnDef="minRate">
          <th mat-header-cell *matHeaderCellDef> Min Rate ({{currencySymbol}})</th>
          <td mat-cell *matCellDef="let row"> {{row.minRate}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="weightColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: weightColumns;"></tr>
      </table>
  </div>
  <div #noRates *ngIf="!rateCardArray.length && !weightRateArray.length">
    <div class="noRates" style="padding-top: 30px; text-align: center;">
      {{'RATECARD.noRate' | translate}}
    </div>
  </div>
  </div>
</div>